import { Stores } from 'src/common/stores';

export const stores = new Stores();
